module.exports = __webpack_public_path__ + "static/img/Y.a0d6171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lll/Y.png
// module id = 3Ttt
// module chunks = 0